import { COMMON_CONTENT_ACTION_TYPE } from "./common-content.action";

export const commonContentMessageContext = {
	get: COMMON_CONTENT_ACTION_TYPE.getCommonContent,
};
